import {Routes} from '@angular/router';
import {IndexComponent as DiagnosisIndexComponent} from './index/index.component';
import {canActivateGuard} from '../../../guards/can-activate-guard';
import {PERMISSION} from '@generated-backend-types';
import EditComponent from './edit/edit.component';
import {DiagnosisService} from '../../../services/api/diagnosis.service';

export const routes: Routes = [
  {
    path: '',
    component: DiagnosisIndexComponent,
    canActivate: [canActivateGuard],
    data: {
      allPermissionsNeeded: [PERMISSION.ADMINISTRATION_DIAGNOSIS_UPDATE_ALL],
      breadcrumb: [
        {
          label: 'authenticated.administration.diagnoses.index.breadcrumb',
          translate: true,
          route: '/administration/diagnoses'
        },
      ]
    }
  },
  {
    path: 'add',
    component: EditComponent,
    canActivate: [canActivateGuard],
    data: {
      allPermissionsNeeded: [PERMISSION.ADMINISTRATION_DIAGNOSIS_CREATE_ALL],
      breadcrumb: [
        {
          label: 'authenticated.administration.diagnoses.index.breadcrumb',
          translate: true,
          route: '/administration/diagnoses'
        },
        {label: 'authenticated.administration.diagnoses.create.breadcrumb', translate: true,},
      ]
    }
  },
  {
    path: ':id',
    component: EditComponent,
    canActivate: [canActivateGuard],
    resolve: {
      diagnosis: DiagnosisService,
    },
    data: {
      allPermissionsNeeded: [PERMISSION.ADMINISTRATION_DIAGNOSIS_UPDATE_ALL],
      breadcrumb: [
        {
          label: 'authenticated.administration.diagnoses.index.breadcrumb',
          translate: true,
          route: '/administration/diagnoses'
        },
        {dynamic: true, dataKey: 'diagnosis.title', route: '/administration/diagnoses/:id'},
        {label: 'authenticated.administration.diagnoses.edit.breadcrumb', translate: true,},
      ]
    }
  }
];
